import Service from '@ember/service';

import { service } from '@ember/service';
import { action } from '@ember/object';

export default class DatasetService extends Service {
  @service routing;

  @action urlFn(...route) {
    return this.routing.fullUrlFor(...route);
  }
}
